<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row align-content="center" align="center" justify="center">
      <v-col cols="12" class="py-12">
        <v-container>
          <v-row>
            <v-col cols="12" lg="8">
              <div class="px-2">
                <div class="home-header-2 mt-6 mb-8">
                  Watch out for scams
                </div>
                <div class="mb-12 home-text-2">
                  <p class="mb-4">
                    Vaccinations are free of charge to eligible individuals on the health service. The health service will never ask for:
                  </p>
                  <ul>
                    <li>your bank account or card details</li>
                    <li>your pin or banking password  </li>
                    <li>copies of personal documents to prove your identity such as your passport, driving licence, bills or pay slips  </li>
                  </ul>
                  <br />
                  <p>
                    If you think you have been a victim of fraud or identify theft, report it to Action Fraud on 0300 123 2040.
                  </p>
                  <p>
                    If you get a suspicious email send it to the National Cyber Security Centre’s suspicious email reporting service by emailing <a href="mailto:report@phishing.gov.uk">report@phishing.gov.uk</a>.
                  </p>
                  <p>
                    If you get a suspicious text, forward it to 7726 and it will be investigated. You can read more about this service <a href="https://www.ncsc.gov.uk/guidance/suspicious-email-actions">by clicking here</a>.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'WatchOutForScams'
};
</script>
